let call_on_element = (actionData) => {
    let $el = $(actionData.selector);
    $el[actionData.function](actionData.args);
};
export default call_on_element;